export default {
  startingFrom: {
    id: 'list_view_starting_from',
    defaultMessage: 'starting from:',
  },
  notDefinedAttribute: {
    id: 'list_view_not_defined_attribute',
    defaultMessage: 'ND',
  },
  originalPriceAriaLabel: {
    id: 'product_thumb_original_price_aria_label',
    defaultMessage: 'Instead of { originalPrice }',
  },
}
